@let smwDataValue = smwData();
@let latestWebcamImagesValue = latestWebcamImages();
@let greenTableDesignValue = smwService.greenTableDesign();
@let langSignalValue = languageService.langSignal();
@if (!isLoading()) {
  <div class="dashboard-smw-content">
    <!-- WHOLE SMW TABLE -->
    @for (station of sortedStations(); track $index) {
      @if (
        smwDataValue &&
        smwDataValue.hasOwnProperty(station.id) &&
        (smwDataValue[station.id].hasOwnProperty('tt') ||
          smwDataValue[station.id].hasOwnProperty('road_tt'))
      ) {
        <!-- SINGLE STATION -->
        <div class="dashboard-smw-content__single-station">
          <div class="dashboard-smw-content__table-container">
            <!-- STATION NAME -->
            <div>{{ station.name }}</div>
            <!-- STATION DATA -->
            <table>
              <!-- 1.row -->
              <tr>
                <!-- Parameter tt -->
                @let ttValue =
                  smwDataValue?.[station.id]?.['tt']
                    ? smwDataValue[station.id]['tt'].toFixed(1) + '°C'
                    : '';
                <td class="dashboard-smw-content__td">
                  @if (ttValue) {
                    <fa-icon [icon]="['far', 'thermometer-half']"></fa-icon>
                  }
                </td>
                <td
                  class="dashboard-smw-content__td"
                  [ngClass]="
                    smwDataValue[station.id]
                      | getColor: 'tt' : greenTableDesignValue
                  ">
                  {{ ttValue }}
                </td>
                @let tdValue =
                  smwDataValue?.[station.id]?.['td']
                    ? smwDataValue[station.id]['td'].toFixed(1) + '°C'
                    : '';
                <!-- Parameter td -->
                <td class="dashboard-smw-content__td">
                  @if (tdValue) {
                    <fa-icon [icon]="['far', 'dewpoint']"></fa-icon>
                  }
                </td>
                <td class="dashboard-smw-content__td">
                  {{ tdValue }}
                </td>
              </tr>
              @let roadttValue =
                smwDataValue?.[station.id]?.['road_tt']
                  ? smwDataValue[station.id]['road_tt'].toFixed(1) + '°C'
                  : smwDataValue?.[station.id]?.['road_tt2']
                    ? smwDataValue[station.id]['road_tt2'].toFixed(1) + '°C'
                    : smwDataValue?.[station.id]?.['road_tt3']
                      ? smwDataValue[station.id]['road_tt3'].toFixed(1) + '°C'
                      : '';
              @if (roadttValue) {
                <!-- 2. row -->
                @let roadConditionValue =
                  smwDataValue?.[station.id]?.['road_condition']
                    ? ('MAPPING.GMA_ROAD_CONDITION_SHORT.' +
                        smwDataValue[station.id]['road_condition'] | translate)
                    : smwDataValue?.[station.id]?.['road_condition2']
                      ? ('MAPPING.GMA_ROAD_CONDITION_SHORT.' +
                          smwDataValue[station.id]['road_condition2']
                        | translate)
                      : smwDataValue?.[station.id]?.['road_condition3']
                        ? ('MAPPING.GMA_ROAD_CONDITION_SHORT.' +
                            smwDataValue[station.id]['road_condition3']
                          | translate)
                        : '';
                <tr>
                  <td class="dashboard-smw-content__td">
                    @if (roadttValue) {
                      <fa-icon [icon]="['far', 'road']"></fa-icon>
                    }
                  </td>
                  <td
                    class="dashboard-smw-content__td"
                    [ngClass]="
                      smwDataValue[station.id]
                        | getColor: 'road_tt' : greenTableDesignValue
                    ">
                    {{ roadttValue }}
                  </td>
                  <td
                    class="dashboard-smw-content__td"
                    [ngClass]="
                      smwDataValue[station.id]
                        | getColor: 'road_condition' : greenTableDesignValue
                    ">
                    {{ roadConditionValue }}
                  </td>
                  @if (station.gmaAlarm) {
                    <td class="dashboard-smw-content__td">
                      @if (smwDataValue[station.id]['gmaAlarm']) {
                        <div
                          class="alarm"
                          matTooltip="{{
                            'PRODUCT.SMW.Alarm.' +
                              smwService.gmaAlarmText[
                                smwDataValue[station.id]['gmaAlarm']
                              ] | translate
                          }}"
                          [ngStyle]="{
                            borderColor:
                              'transparent transparent ' +
                              smwService.gmaAlarmColors[
                                smwDataValue[station.id]['gmaAlarm']
                              ] +
                              ' transparent',
                          }">
                          <p>{{ smwDataValue[station.id]['gmaAlarm'] }}</p>
                        </div>
                      } @else {
                        --
                      }
                    </td>
                  }
                </tr>
              }
              @let t5Value =
                smwDataValue?.[station.id]?.['t5']
                  ? smwDataValue[station.id]['t5'].toFixed(1) + '°C'
                  : '';
              @if (t5Value) {
                <tr>
                  <td class="dashboard-smw-content__td">
                    <ng-container
                      appWmIcon
                      [inputParameter]="'t5'"></ng-container>
                  </td>
                  <td class="dashboard-smw-content__td">
                    {{ t5Value }}
                  </td>
                </tr>
              }
            </table>
          </div>
          <!-- WEBCAM IMAGE CONTAINER -->
          <div class="dashboard-smw-content__webcam-container">
            <ng-container
              *ngTemplateOutlet="
                latestWebcamImagesValue[station.id] ? webcam : onlyDate;
                context: { station: station }
              "></ng-container>
          </div>
        </div>
        <hr />
      }
    }
  </div>
} @else {
  <app-loading-overlay text="Daten werden geladen..." [fullScreen]="false">
  </app-loading-overlay>
}

<!-- TEMPLATES -->
<ng-template #webcam let-station="station">
  <div class="dashboard-smw-content__date">
    {{
      smwDataValue[station.id]['dtg']
        | datex: 'DD.MM' : undefined : langSignalValue
    }}
    &#124;
    {{
      smwDataValue[station.id]['dtg']
        | datex: 'HH:mm' : undefined : langSignalValue
    }}
  </div>
  <img alt="station-webcam-image" [src]="latestWebcamImagesValue[station.id]" />
</ng-template>

<ng-template #onlyDate let-station="station">
  @let t5Value =
    smwDataValue?.[station.id]?.['t5']
      ? smwDataValue[station.id]['t5'].toFixed(1) + '°C'
      : '';
  @let roadttValue =
    smwDataValue?.[station.id]?.['road_tt']
      ? smwDataValue[station.id]['road_tt'].toFixed(1) + '°C'
      : smwDataValue?.[station.id]?.['road_tt2']
        ? smwDataValue[station.id]['road_tt2'].toFixed(1) + '°C'
        : smwDataValue?.[station.id]?.['road_tt3']
          ? smwDataValue[station.id]['road_tt3'].toFixed(1) + '°C'
          : '';
  <div
    class="dashboard-smw-content__date-only"
    [ngClass]="t5Value || roadttValue ? 'tt-two-lines' : 'tt-one-line'">
    <b>{{
      smwDataValue[station.id]['dtg']
        | datex: 'HH:mm' : undefined : langSignalValue
    }}</b>
    <br />
    {{
      smwDataValue[station.id]['dtg']
        | datex: 'dd DD.MM' : undefined : langSignalValue
    }}
  </div>
</ng-template>
